export const ABOUT_YOU_STEP = "about-you";
export const CUSTOMIZATION_STEP = "customization";
export const PLAN_SELECTION_STEP = "plan-selection";
export const LOADING_STEP = "loading";

export const ONBOARDING_STEPS = [
  ABOUT_YOU_STEP,
  CUSTOMIZATION_STEP,
  PLAN_SELECTION_STEP,
] as const;

// FIXME: WARNING, all those constants must not be changed lightly, as they are used in the data pipeline, in particular
// in the google sheet used for lead scoring. Please update the associated tools if you change anything.
export const ANIMATION_AND_GAMING_INDUSTRY = "Animation & Gaming";
export const CREATIVE_OR_COMMUNICATION_AGENCIES_INDUSTRY =
  "Creative or Communication Agencies";
export const UNIVERSITY_OR_SCHOOL_INDUSTRY = "University or School";
export const FASHION_INDUSTRY = "Fashion";
export const RETAIL_INDUSTRY_AND_CONSUMER_GOODS = "Retail & Consumer Goods";
export const BEAUTY_AND_SKINCARE_INDUSTRY = "Beauty & Skincare";
export const TRAVELS_AND_HOSPITALITY_INDUSTRY = "Travels & Hospitality";
export const FOOD_AND_BEVERAGE_INDUSTRY = "Food & Beverage";
export const TECH_INDUSTRY = "Tech";
export const REAL_ESTATE_INDUSTRY = "Real Estate";
export const OTHER_INDUSTRY = "Other";

export const INDUSTRY_OPTIONS = [
  ANIMATION_AND_GAMING_INDUSTRY,
  CREATIVE_OR_COMMUNICATION_AGENCIES_INDUSTRY,
  UNIVERSITY_OR_SCHOOL_INDUSTRY,
  FASHION_INDUSTRY,
  RETAIL_INDUSTRY_AND_CONSUMER_GOODS,
  BEAUTY_AND_SKINCARE_INDUSTRY,
  TRAVELS_AND_HOSPITALITY_INDUSTRY,
  FOOD_AND_BEVERAGE_INDUSTRY,
  TECH_INDUSTRY,
  REAL_ESTATE_INDUSTRY,
  OTHER_INDUSTRY,
] as const;

// FIXME: WARNING, all those constants must not be changed lightly, as they are used in the data pipeline, in particular
// in the google sheet used for lead scoring and hubspot fields (which are enumerations, and will fail if the option is not present).
// Please update the associated tools if you change anything.
export const TEAM_SIZE_OPTIONS = ["0-10", "11-49", "50-200", "200+"] as const;

export const CUSTOMIZATION_STEP_INDUSTRY = "industry";
export const CUSTOMIZATION_STEP_OCCUPATION = "occupation";
export const CUSTOMIZATION_STEPS = [
  CUSTOMIZATION_STEP_INDUSTRY,
  CUSTOMIZATION_STEP_OCCUPATION,
] as const;
